import React, { useEffect, useState } from 'react';
import {
  Card,
  Row,
  CardTitle,
  CardBody,
  Button,
  FormGroup,
  Label,
  Input,
} from 'reactstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import VendorBranchSelector from '../../components/VendorBranchSelector';
import { useSelector } from 'react-redux';
import { apiService } from '../../constants/ApiService';
import { toast } from 'react-toastify';
import useVendorBranch from '../../utils/useVendorBranch';

const AddEditWeekend = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useSelector((state) => state.authState);

  const { isSuperAdmin, isAdmin, hasMultiBranch } = useVendorBranch(user);

  const [weekendData, setWeekendData] = useState({
    id: 0,
    vendor_id: 0,
    branch_id: 0,
    day_of_week: '',
    is_working: false,
    academic_year: '',
  });

  const [errorMessage, setErrorMessage] = useState({});


  useEffect(() => {
    if (location.state) {
      setWeekendData((prev) => ({
        ...prev,
        ...location.state,
      }));
    }
  }, [location.state]);

  const onChangeHandle = (e) => {
    const { name, value, type, checked } = e.target;
    setWeekendData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const SaveWeekend = async () => {
    if (
      isSuperAdmin &&
      (!weekendData.vendor_id || weekendData.vendor_id <= 0)
    ) {
      toast.error('Please select Vendor');
      return;
    }

    if (
      (isSuperAdmin || isAdmin || hasMultiBranch) &&
      (!weekendData.branch_id || weekendData.branch_id <= 0)
    ) {
      toast.error('Please select Branch');
      return;
    }

    if (weekendData.day_of_week === '' || weekendData.day_of_week === null) {
      toast.error('Please select Day of Week');
      return;
    }

    if (!weekendData.academic_year) {
      toast.error('Please select Academic Year');
      return;
    }

    try {
      let res;

      const payload = {
        ...weekendData,
        day_of_week:
          weekendData.day_of_week === '' || weekendData.day_of_week === null
            ? null
            : Number(weekendData.day_of_week),
      };

      if (weekendData.id && weekendData.id > 0) {
        res = await apiService.put(
          `api/HolidayMaster/UpdateWeekend?id=${weekendData.id}`,
          payload
        );
      } else {
        res = await apiService.post('api/HolidayMaster/AddWeekend', payload);
      }

      if (res?.status === true) {
        toast.success(res.message);
        navigate('/list-weekend');
      } else {
        toast.error(res?.message || 'Failed');
      }
    } catch (err) {
      console.error(err);
      toast.error('Something went wrong');
    }
  };

  return (
    <>
      {/* ✅ EXACT SAME STYLE AS HOLIDAY */}
      <VendorBranchSelector
        user={user}
        selectionData={weekendData}
        setSelectionData={setWeekendData}
        accessButton={true}
        errorMessage={errorMessage}
      />

      <Card className='card-box pd-20 mb-20'>
        <CardTitle className='border-bottom p-3 d-flex justify-content-between align-items-center'>
          <span>Weekend Form</span>
          <Button color='warning' onClick={() => navigate(-1)}>
            <i className='bi bi-arrow-left' />
          </Button>
        </CardTitle>

        <CardBody>
          <Row>
            <FormGroup className='col-sm-6'>
              <Label>Day Of Week</Label>
              <Input
                type='select'
                name='day_of_week'
                className='custom-select'
                value={weekendData.day_of_week}
                onChange={onChangeHandle}
              >
                <option value=''>Select</option>
                <option value='0'>Sunday</option>
                <option value='1'>Monday</option>
                <option value='2'>Tuesday</option>
                <option value='3'>Wednesday</option>
                <option value='4'>Thursday</option>
                <option value='5'>Friday</option>
                <option value='6'>Saturday</option>
              </Input>
            </FormGroup>

            <FormGroup className='col-sm-6'>
              <Label>Academic Year</Label>
              <Input
                type='date'
                name='academic_year'
                value={weekendData.academic_year || ''}
                onChange={onChangeHandle}
              />
            </FormGroup>

            {/* if you want, enable working checkbox */}
            {/* <FormGroup className='col-sm-6 mt-2'>
              <Label check>
                <Input
                  type='checkbox'
                  name='is_working'
                  checked={!!weekendData.is_working}
                  onChange={onChangeHandle}
                />{' '}
                Working Day
              </Label>
            </FormGroup> */}
          </Row>

          <Button
            color='primary'
            className='float-end mt-3'
            onClick={SaveWeekend}
          >
            Save
          </Button>
        </CardBody>
      </Card>
    </>
  );
};

export default AddEditWeekend;
